import React from "react";
import UserQuizRankDetailModal from "./UserQuizRankDetailModal";
import { convertDateToLocalTimeWithHour } from "../../assets/utils/UtilsFunctons";
import SortAndSearchTable from "../table/sortAndSearchTable/SortAndSearchTable";

const QuizRanksContentsTable = ({ data }) => {
  const columns = [
    {
      Header: "Rang",
      accessor: "rank",
      Cell: ({ row, value }) => (
        <span style={{ opacity: row.original.isGuide ? 0.5 : 1 }}>
          {value}
        </span>
      ),
    },
    {
      Header: "Prénom & Nom",
      accessor: (row) => row.userFirstName + " " + row.userLastName,
      Cell: ({ row, value }) => (
        <span style={{ opacity: row.original.isGuide ? 0.5 : 1 }}>
          {value}{" "}
          {row.original.isGuide && (
            <em style={{ fontSize: "11px", color: "#aaa" }}>(Guide)</em>
          )}
        </span>
      ),
    },
    {
      Header: "Score",
      accessor: "totalScore",
      Cell: ({ row, value }) => (
        <span style={{ opacity: row.original.isGuide ? 0.5 : 1 }}>{value}</span>
      ),
    },
    {
      Header: "Récompenses",
      Cell: ({ row }) =>
        row.original.isGuide ? (
          <em style={{ color: "#aaa", fontSize: "12px" }}>Hors classement</em>
        ) : (
          <span>🪙 {row.original.coinsEarned} / 💎 {row.original.scoreEarned}</span>
        ),
    },
    {
      Header: "Lancement",
      accessor: "startDate",
      Cell: ({ value }) => convertDateToLocalTimeWithHour(value),
    },
    {
      Header: "Temps de réponse",
      accessor: "fullAnswerTime",
      Cell: ({ row, value }) => (
        <span style={{ opacity: row.original.isGuide ? 0.5 : 1 }}>{value}</span>
      ),
    },
    {
      Header: "Bonnes réponses",
      accessor: "goodAnswerCount",
      Cell: ({ row, value }) => (
        <span style={{ opacity: row.original.isGuide ? 0.5 : 1 }}>{value}</span>
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => <UserQuizRankDetailModal data={row.original} />,
    },
  ];

  const tableHooks = () => {
    "";
  };
  const handleRowClicked = () => {
    "";
  };
  return (
    <div>
      <div>
        <SortAndSearchTable data={data} columns={columns} tableHooks={tableHooks} refresh={data} handleRowClicked={handleRowClicked}></SortAndSearchTable>
      </div>
    </div>
  );
};

export default QuizRanksContentsTable;
